// The five products the shared policy screens serve, and the product switcher
// mode each belongs to. Plain data: the sidebar reads it to keep the switcher
// in step with /pam/policies/:product links, without loading the screens.
export const POLICY_PRODUCTS = {
  ad: { key: "ad", label: "Identity", modeKey: "mfa_ad" },
  ssh: { key: "ssh", label: "PAM", modeKey: "mfa_pam" },
  radius: { key: "radius", label: "RADIUS", modeKey: "mfa_radius" },
  database: { key: "database", label: "Database", modeKey: "mfa_db" },
  apps: { key: "apps", label: "Applications", modeKey: "mfa_apps" },
};

export const POLICY_PRODUCT_KEYS = Object.keys(POLICY_PRODUCTS);

export const isPolicyProduct = (key) => Object.prototype.hasOwnProperty.call(POLICY_PRODUCTS, key);

// "mfa_pam" -> "ssh". Older modes ("pam") read as their MFA twin.
export function productForMode(modeKey) {
  const m = modeKey === "pam" ? "mfa_pam" : modeKey;
  return POLICY_PRODUCT_KEYS.find((k) => POLICY_PRODUCTS[k].modeKey === m) || null;
}

export const modeForProduct = (key) => POLICY_PRODUCTS[key]?.modeKey || null;

// "/pam/policies/ssh/123/edit" -> "ssh"; null for any other path.
export function productFromPath(pathname) {
  const m = /^\/pam\/policies\/([^/]+)/.exec(String(pathname || ""));
  return m && isPolicyProduct(m[1]) ? m[1] : null;
}

export const policiesPath = (product, rest = "") => `/pam/policies/${product}${rest ? `/${rest}` : ""}`;
